// VALIDATION

const getFileExtension = (file: File): Maybe<string> => {
  const fileExtentionMatch = file && file.name.match(/\.([^.]+)$/)
  return fileExtentionMatch && fileExtentionMatch[0]
}

// Types definition

export const imageInputTypes = ['image/jpeg', 'image/png', 'image/gif']
export const pdfInputTypes = [...imageInputTypes, 'application/pdf']

// Extensions definition

export const imageInputExtensions = ['.gif', '.jpeg', '.png']
export const pdfInputExtensions = [...imageInputExtensions, '.pdf']

export const validateInputPdfFile = (file: File): boolean => {
  const fileExtension = getFileExtension(file)

  const isValid =
    file &&
    ((fileExtension && pdfInputExtensions.includes(fileExtension)) ||
      pdfInputTypes.includes(file.type))

  return isValid
}

export const validateInputImageFile = (file: File): boolean => {
  const fileExtension = getFileExtension(file)

  const isValid =
    file &&
    ((fileExtension && imageInputExtensions.includes(fileExtension)) ||
      imageInputTypes.includes(file.type))

  return isValid
}

export const validateFileSize = (
  fileSize: number,
  limitInMb: number
): boolean => {
  const fileSizeInMB = fileSize / 1000000

  return fileSizeInMB <= limitInMb
}

// DOWNLOAD

export const downloadFile = (file: Blob, fileName: string): void => {
  // for IE we need to use msSaveOrOpenBlob and we are done
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(file)
    return
  }
  // for all other browser we need to create a fake link
  const objectURL = window.URL.createObjectURL(file)
  const link = document.createElement('a')
  link.href = objectURL
  link.download = fileName
  link.click()
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(objectURL)
  }, 100)
}
